import React, { useCallback, useEffect } from 'react'
import { ContentBlock } from 'components/ContentBlock'
import CashRegisterTree from 'components/CashRegisterTree'
import get from 'helpers/get'


const CashRegisters = ({ data, mutations: { updateItem } }) => {
	const kasseIdArr = get(['cashRegisterId'], data)
	const onChange = useCallback(cashRegisterId => updateItem({ cashRegisterId }), [])

	return(
		<ContentBlock>
			<CashRegisterTree withContext activeNodesArr={kasseIdArr} onChange={onChange} />
		</ContentBlock>
	)
}


export default CashRegisters
